module.exports = "<div id=\"injectedPasswordRecovery\" ng-show=\"loaded\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/password-recovery/template.html
// module id = ./components/xo-login-components/src/password-recovery/template.html
// module chunks = 1